<script>
  import { getPath } from '../../utils/imageKit.ts';
  import DrugSearch from '../DrugSearch/DrugSearch.svelte';
  
  let {
    headingText = $bindable(),
    headingLevel = 'h1',
    backgroundImage,
    alignment,
    drugSearch,
    dataTestId = 'search-promo-cobrand',
    lang,
  } = $props();

  // Handle Image Setup
  const smSrc = getPath(backgroundImage, { w: 180 });
  const mdSrc = getPath(backgroundImage, { w: 360 });
  const lgSrc = getPath(backgroundImage, { w: 360 }, 2);

  // remove html tags from heading content
  headingText = headingText && headingText.content ? headingText.content.replace(/<\/?[^>]+(>|$)/g, '') : undefined;
</script>

<div class="flex justify-center relative bg-blue-very-light" data-testid={dataTestId}>
  <div
    class="flex flex-col {alignment === 'left'
      ? 'md:flex-row-reverse'
      : 'md:flex-row'} items-center relative max-w-100 md:w-full md:max-w-full md:min-h-56 lg:min-h-120 lg:max-w-6xl"
  >
    <div
      class="w-full md:w-1/2 md:items-start p-4 md:py-16 {alignment === 'left'
        ? 'lg:pr-1'
        : 'lg:pl-1'} lg:py-20 md:relative flex flex-col items-center"
    >
      {#if headingText}
        {#if headingLevel === 'h1'}
          <h1
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left md:max-w-xs lg:max-w-md xl:max-w-none"
            data-testid="search-promo-heading"
          >
            {@html headingText}
          </h1>
        {:else if headingLevel === 'h2'}
          <h2
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left md:max-w-xs lg:max-w-md xl:max-w-none"
            data-testid="search-promo-heading"
          >
            {@html headingText}
          </h2>
        {:else if headingLevel === 'h3'}
          <h3
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left md:max-w-xs lg:max-w-md xl:max-w-none"
            data-testid="search-promo-heading"
          >
            {@html headingText}
          </h3>
        {:else}
          <h4
            class="ml-3 md:relative md:z-10 mb-4 md:mb-6 px-3 md:px-0 text-center leading-tight text-blue-navy
            text-1.5xl md:text-2xl lg:text-3xl md:text-left md:max-w-xs lg:max-w-md xl:max-w-none"
            data-testid="search-promo-heading"
          >
            {@html headingText}
          </h4>
        {/if}
      {/if}
      <DrugSearch {...drugSearch} {lang} />
    </div>
    <div
      class="md:w-1/2 h-full p-4 md:py-16 {alignment === 'left'
        ? 'lg:pl-1'
        : 'lg:pr-1'} lg:py-20 flex items-center justify-center"
    >
      <img
        class="object-contain h-auto w-full max-w-sm"
        src={backgroundImage.url}
        alt={backgroundImage.alt}
        width="187"
        height="135"
        srcset={`${backgroundImage.url} 1w, ${smSrc} 180w, ${mdSrc} 360w, ${lgSrc} 720w`}
        sizes="(min-width: 768px) 184px, (min-width: 1024px) 324px, (min-width: 1280px) 365px"
      />
    </div>
  </div>
</div>
